/* eslint-disable */
import React, { useState } from 'react';
import {injectIntl, FormattedHTMLMessage} from 'react-intl';
import styled from '@emotion/styled';
import {When} from "react-if";
import sendEvent from '../../../../helpers/sendAnalytics'
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion';

import { Waypoint } from 'react-waypoint';
import IsDesktop from "../../../common/IsDesktop";
import IsMobile from "../../../common/IsMobile";

import BlueShape from "../../../../assets/pets2023/blue-shapes.jpg";

import Slider from "react-slick";
import SlideUp from "../../../../assets/pets2023/slide-up.svg";
import AdoptionBackground from "../../../../assets/pets-images/adoption-section-background.jpg";


const BoxedShadow = styled.div`
  padding: 75px 0px;
  box-shadow: 0px 0px 15px #dbdbdb;
  width: 100%;
  margin: 50px 0 100px;
  position: relative;
  z-index: 999;
  background-image: url("${AdoptionBackground}");
  @media screen and (max-width: 1080px) {
    width: 100%;
    margin: 50px 0 0;
    padding: 0;
  }
`

const PetsAmbassadorBox = styled.div`
  ${tw`mx-auto relative bg-white`}
  width: 1240px;
  background-image: url("${BlueShape}");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: bottom;
  overflow: hidden;

  @media screen and (max-width: 1240px) {
    width: 1020px;
  }

  #pets-ambassador-list {
    position: relative;
    margin: 0;
    padding: 0;
    list-style: none;
    display: flex;
    width: 100%;
    li {
      background-color: #F0F0F0;
      margin: 2px 1px;
      width: 20%;
      padding: 0px;
      text-align:center;
      position:relative;
      overflow: hidden;
      &.active {
      background-color: #AEE2FA;
        &:after {
          position: absolute;
          content: '';
          width: 30px;
          height: 30px;
          display: block;
          transform: rotate(45deg);
          background-color: white;
          bottom: -15px;
          left: calc(50% - 15px);
        }
        button {
          opacity: 1;
        }
      }
      button {
        border-radius: 100%;
        background-color: transparent;
        border: 0;
        opacity: 0.3;
        cursor: pointer;
        font-family: "Montserrat", "sans-serif";
        text-align:center;
        padding: 35px 0px;
        width: 100%;
        b {
          display: block;
        }

      }
    }
  }
`

const PetsAmbassadorSection = styled.section`
  position: relative;
`

const Header = styled.div`
  width: 1240px;
  margin: 0 auto;
  p {
    ${tw`font-montserrat font-normal text-white text-lg m-0 mb-16 ml-1`}
  }
  @media screen and (max-width: 1240px) {
    width: 1020px;
  }
`

const HeaderText = styled.h2`
  ${tw`font-montserrat text-white font-light text-5xl m-0 mb-4`}
`

const TextWrapper = styled.div`
  display: flex;
  max-width: 900px;

  h4 {
    ${tw`font-montserrat font-normal text-3xl m-0 mb-4 leading-normal`}
  }

  p {
    ${tw`font-raleway font-medium m-0 mb-4 leading-loose`}
  }
  color: #434343;
`

const QuoteBox = styled.div`
  ${tw`relative font-montserrat text-center font-normal text-lg bg-white shadow-md pt-12 px-4 pb-8 my-8`}
  border-radius: 25px;
  color: #34B7FF;
  img {
    position: absolute;
    top: -35px;
    left: calc(50% - 35px);
    width: 70px;
  }
`

const Column1 = styled.div`
  width: 50%;
  padding: 35px;
`

const Column2 = styled.div`
  width: 50%;
  padding: 35px;
`

const Image = styled.img`
  position: absolute;
  width: 500px;
`

const MobileImage = styled.img`
  ${tw`px-4 m-auto`}
`

const Slide = styled.div`
  ${tw`relative p-8 text-white font-montserrat font-normal text-md text-center`}
  background-color: #292C94;
  margin: 170px 0 100px;
  padding-top: 140px;
  padding-bottom: 100px;
  .person {
    position: absolute;
    width: 228px;
    top: -160px;
    left: calc(50% - 114px);
  }
  .slide-up {
    position: absolute;
    width: 100px;
    bottom: -50px;
    left: calc(50% - 50px);

  }
  .line {
    width: 100px;
    height: 4px;
    background: white;
    display: block;
    margin: 25px auto;
  }
  h4 {
    ${tw`text-3xl m-0 mb-8`}
  }
  button{
    position: relative;
    z-index: 9999;
    background: transparent;
    border: 0;
    color: white;
    text-transform: uppercase;
    text-decoration: underline;
    font-weight: bold;
    margin-bottom: 20px;
  }
  .slide-open {
    display: none;
    &.slide-active {
      display: block;
      margin-bottom: 25px;
    }
  }
`



const MobileHeaderText = styled.div`
  ${tw`font-montserrat font-normal m-0 mb-4 leading-normal text-center px-4`}
  h2 {
    color: black;
    font-size: 2.5rem;
  }
  p {
    max-width: 250px;
    margin: 0 auto;
    font-size: 1.2rem;
  }
`

const PetsAmbassador = ({intl}) => {
  const [slide, setSlide] = useState(0);
  const [slideOpen, setSlideOpen] = useState(99);
  const [firstEventSent, setSent] = useState(false);

  const settings = {
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    autoplay: false,
    pauseOnHover: false,
    adaptiveHeight: true,
  };

  return (
    <>
      <Waypoint
        onEnter={() => {
          if(!firstEventSent) {
            sendEvent({ ga: { category: 'PETS_AMBASSADOR_2023', action: 'View', Label: (intl.locale === 'en') ? 'Franklin_View' : 'Franklin_View_FR'}})
            setSent(true)
          }
        }}
      />
      <IsDesktop>
        <PetsAmbassadorSection id="ambassador">
          <BoxedShadow>
            <Header>
              <HeaderText>
                <FormattedHTMLMessage id="petspage.ambassadorHeader" />
              </HeaderText>
              <p><FormattedHTMLMessage id="petspage.ambassadorText" /></p>
            </Header>
            <PetsAmbassadorBox>
              <ul id="pets-ambassador-list">
                <li className={slide === 0 ? 'active' : ''}>
                  <button type="button" onClick={() => {
                    setSlide(0)
                    sendEvent({ ga: { category: 'PETS_AMBASSADOR_2023', action: 'Click', Label: (intl.locale === 'en') ? 'Franklin_Click' : 'Franklin_Click_FR'}})
                  }}>
                    <b>Franklin</b>
                    { intl.locale == 'fr' ? 'et':'&'} Penny Oleksiak
                  </button>
                </li>
                <li className={slide === 1 ? 'active' : ''}>
                  <button type="button" onClick={() => {
                    setSlide(1)
                    sendEvent({ ga: { category: 'PETS_AMBASSADOR_2023', action: 'Click', Label: (intl.locale === 'en') ? 'Ace_Click' : 'Ace_Click_FR'}})
                  }}>
                    <b>Ace</b>
                    { intl.locale == 'fr' ? 'et':'&'} Kevin Wendt
                  </button>
                </li>
                <li className={slide === 2 ? 'active' : ''}>
                  <button type="button" onClick={() => {
                    setSlide(2)
                    sendEvent({ ga: { category: 'PETS_AMBASSADOR_2023', action: 'Click', Label: (intl.locale === 'en') ? 'Pearl_Click' : 'Pearl_Click_FR'}})
                  }}>
                    <b>Pearl</b>
                    { intl.locale == 'fr' ? 'et':'&'} Elizabeth Spence
                  </button>
                </li>
                <li className={slide === 3 ? 'active' : ''}>
                  <button type="button" onClick={() => {
                    setSlide(3)
                    sendEvent({ ga: { category: 'PETS_AMBASSADOR_2023', action: 'Click', Label: (intl.locale === 'en') ? 'Bonhomme_Click' : 'Bonhomme_Click_FR'}})
                  }}>
                    <b>Bonhomme</b>
                    { intl.locale == 'fr' ? 'et':'&'} John Rush
                  </button>
                </li>
                <li className={slide === 4 ? 'active' : ''}>
                  <button type="button" onClick={() => {
                    setSlide(4)
                    sendEvent({ ga: { category: 'PETS_AMBASSADOR_2023', action: 'Click', Label: (intl.locale === 'en') ? 'Merida_Click' : 'Merida_Click_FR'}})
                  }}>
                    <b>Merida</b>
                    { intl.locale == 'fr' ? 'et':'&'} Alexe Wolfe
                  </button>
                </li>
              </ul>
              <When condition={slide === 0}>
                <TextWrapper>
                  <Column1>
                    <h4>
                      <FormattedHTMLMessage id="petspage.text52" />
                    </h4>
                    <p>
                      <FormattedHTMLMessage id="petspage.text53" />
                    </p>
                  </Column1>
                  <Column2>
                    <QuoteBox>
                    <img 
                        src="https://img.imageboss.me/royale-images/width/84/format:webp/images/pets/quote.svg" 
                        alt="Quote sign" 
                      />
                      <FormattedHTMLMessage id="petspage.quote1" />
                    </QuoteBox>
                    <p>
                      <FormattedHTMLMessage id="petspage.text54" />
                    </p>
                  </Column2>
                </TextWrapper>
                <Image src="https://img.imageboss.me/royale-images/width/384/format:webp/images/pets/PennyBig.png"
                alt="Penny Oleksiak and Franklin" style={{bottom:"-1px",right:"-1px",width:"320px"}} />
              </When>

              <When condition={slide === 1}>
                <TextWrapper>
                  <Column1>
                    <h4>
                      <FormattedHTMLMessage id="petspage.text57" />
                    </h4>
                    <p>
                      <FormattedHTMLMessage id="petspage.text58" />
                    </p>
                  </Column1>
                  <Column2>
                    <p>
                      <FormattedHTMLMessage id="petspage.text59" />
                    </p>
                  </Column2>
                </TextWrapper>
                <Image src="https://img.imageboss.me/royale-images/width/360/format:webp/images/pets/KevinBig.png"
                alt="Kevin Wendt and Ace" style={{bottom:"-1px",right:"-1px",width:"300px"}} />
              </When>

              <When condition={slide === 2}>
                <TextWrapper>
                  <Column1>
                    <h4>
                      <FormattedHTMLMessage id="petspage.text61" />
                    </h4>
                    <p>
                      <FormattedHTMLMessage id="petspage.text62" />
                    </p>
                  </Column1>
                  <Column2>
                    <p>
                      <FormattedHTMLMessage id="petspage.text63" />
                    </p>
                  </Column2>
                </TextWrapper>
                <Image src="https://img.imageboss.me/royale-images/width/336/format:webp/images/pets/ElizabethBig.png"
                alt="Elizabeth Spence and Pearl" style={{bottom:"-1px",right:"-1px",width:"280px"}} />
              </When>

              <When condition={slide === 3}>
                <TextWrapper>
                  <Column1>
                    <h4>
                      <FormattedHTMLMessage id="petspage.text69" />
                    </h4>
                    <p>
                      <FormattedHTMLMessage id="petspage.text70" />
                    </p>
                  </Column1>
                  <Column2>
                    <p>
                      <FormattedHTMLMessage id="petspage.text71" />
                    </p>
                  </Column2>
                </TextWrapper>
                <Image src="https://img.imageboss.me/royale-images/width/336/format:webp/images/pets/JohnBig.png"
                alt="John Rush and Bonhomme" style={{bottom:"-1px",right:"-1px",width:"335px"}} />
              </When>

              <When condition={slide === 4}>
                <TextWrapper>
                  <Column1>
                    <h4>
                      <FormattedHTMLMessage id="petspage.text65" />
                    </h4>
                    <p>
                      <FormattedHTMLMessage id="petspage.text66" />
                    </p>
                  </Column1>
                  <Column2>
                    <p>
                      <FormattedHTMLMessage id="petspage.text67" />
                    </p>
                  </Column2>
                </TextWrapper>
                <Image src="https://img.imageboss.me/royale-images/width/336/format:webp/images/pets/MeridaBig.png"
                alt="Alexe Wolfe and Merida" style={{bottom:"-7px",right:"-1px",width:"335px"}} />
              </When>
            </PetsAmbassadorBox>
          </BoxedShadow>
        </PetsAmbassadorSection>
      </IsDesktop>
      <IsMobile>
        <MobileHeaderText>
            <HeaderText>
              <FormattedHTMLMessage id="petspage.ambassadorHeader" />
            </HeaderText>
            <p><FormattedHTMLMessage id="petspage.ambassadorText" /></p>
        </MobileHeaderText>
        <div id="ambassador-slider" >
          <Slider className="ambassador-slider" {...settings}>
            <Slide>
              <img className="person" src="https://img.imageboss.me/royale-images/width/275/format:webp/images/pets/pennymobile.png"
              alt="Penny"/>
              <b>Franklin</b> { intl.locale == 'fr' ? 'et':'&'} Penny Oleksiak
              <div className="line"></div>
              <h4>
                <FormattedHTMLMessage id="petspage.text52" />
              </h4>

              {
                slideOpen === 0 ?
                  null:<button onClick={() => setSlideOpen(0)}>{ intl.locale == 'fr' ? 'En savoir plus':'Read more'}</button>
              }

              <div className={slideOpen == 0 ? "slide-open slide-active":"slide-open"}>
                <p>
                  <FormattedHTMLMessage id="petspage.text53" />
                </p>
                <br/><br/>
                <QuoteBox>
                <img 
                        src="https://img.imageboss.me/royale-images/width/84/format:webp/images/pets/quote.svg" 
                        alt="Quote sign" 
                      />
                  <FormattedHTMLMessage id="petspage.quote1" />
                </QuoteBox>
                <p>
                  <FormattedHTMLMessage id="petspage.text54" />
                </p>
                <img className="slide-up" onClick={() => {
                  setSlideOpen(99)
                  document.getElementById('ambassador-slider').scrollIntoView()
                }} src={SlideUp} alt="close slide icon"/>
              </div>
              <p><b>{ intl.locale == 'fr' ? 'Suivant':'Up Next'}</b>: Ace & Kevin Wendt</p>

            </Slide>

            <Slide>
              <img className="person" src="https://img.imageboss.me/royale-images/width/275/format:webp/images/pets/kevinmobile.png"
              alt="Kevin"/>
              <b>Ace</b> { intl.locale == 'fr' ? 'et':'&'} Kevin Wendt
              <div className="line"></div>
              <h4>
                <FormattedHTMLMessage id="petspage.text57" />
              </h4>
              {
                slideOpen === 1 ?
                  null:<button onClick={() => setSlideOpen(1)}>{ intl.locale == 'fr' ? 'En savoir plus':'Read more'}</button>
              }



              <div className={slideOpen == 1 ? "slide-open slide-active":"slide-open"}>
                <p>
                  <FormattedHTMLMessage id="petspage.text58" />
                </p>
                <p>
                  <FormattedHTMLMessage id="petspage.text59" />
                </p>
                <img className="slide-up" onClick={() => {
                  setSlideOpen(99)
                  document.getElementById('ambassador-slider').scrollIntoView()
                }} src={SlideUp} alt="close slide icon"/>
              </div>
              <p><b>{ intl.locale == 'fr' ? 'Suivant':'Up Next'}</b>: Pearl & Elizabeth Spence</p>

            </Slide>

            <Slide>
              <img className="person" src="https://img.imageboss.me/royale-images/width/275/format:webp/images/pets/elizabethmobile.png"
              alt="Elizabeth"/>
              <b>Pearl</b> { intl.locale == 'fr' ? 'et':'&'} Elizabeth Spence
              <div className="line"></div>
              <h4>
                <FormattedHTMLMessage id="petspage.text61" />
              </h4>
              {
                slideOpen === 2 ?
                  null:<button onClick={() => setSlideOpen(2)}>{ intl.locale == 'fr' ? 'En savoir plus':'Read more'}</button>
              }



              <div  className={slideOpen == 2 ? "slide-open slide-active":"slide-open"}>
                <p>
                  <FormattedHTMLMessage id="petspage.text62" />
                </p>
                <p>
                  <FormattedHTMLMessage id="petspage.text63" />
                </p>
                <img className="slide-up" onClick={() => {
                  setSlideOpen(99)
                  document.getElementById('ambassador-slider').scrollIntoView()
                }} src={SlideUp} alt="close slide icon"/>
              </div>
              <p><b>{ intl.locale == 'fr' ? 'Suivant':'Up Next'}</b>: Bonhomme & John Rush</p>

            </Slide>

            <Slide>
              <img className="person" src="https://img.imageboss.me/royale-images/width/275/format:webp/images/pets/johnmobile.png"
              alt="John"/>
              <b>Bonhomme</b> { intl.locale == 'fr' ? 'et':'&'} John Rush
              <div className="line"></div>
              <h4>
                <FormattedHTMLMessage id="petspage.text69" />
              </h4>
              {
                slideOpen === 3 ?
                  null:<button onClick={() => setSlideOpen(3)}>{ intl.locale == 'fr' ? 'En savoir plus':'Read more'}</button>
              }



              <div  className={slideOpen == 3 ? "slide-open slide-active":"slide-open"}>
                <p>
                  <FormattedHTMLMessage id="petspage.text70" />
                </p>
                <p>
                  <FormattedHTMLMessage id="petspage.text71" />
                </p>
                <img className="slide-up" onClick={() => {
                  setSlideOpen(99)
                  document.getElementById('ambassador-slider').scrollIntoView()
                }} src={SlideUp} alt="close slide icon"/>
              </div>
              <p><b>{ intl.locale == 'fr' ? 'Suivant':'Up Next'}</b>: Merida & Alexe Wolfe</p>

            </Slide>

            <Slide>
              <img className="person" src="https://img.imageboss.me/royale-images/width/275/format:webp/images/pets/alexemobile.png"
              alt="Alexe"/>
              <b>Merida</b> { intl.locale == 'fr' ? 'et':'&'} Alexe Wolfe
              <div className="line"></div>
              <h4>
                <FormattedHTMLMessage id="petspage.text65" />
              </h4>
              {
                slideOpen === 4 ?
                  null:<button onClick={() => setSlideOpen(4)}>{ intl.locale == 'fr' ? 'En savoir plus':'Read more'}</button>
              }

              <div  className={slideOpen == 4 ? "slide-open slide-active":"slide-open"}>
                <p>
                  <FormattedHTMLMessage id="petspage.text66" />
                </p>
                <p>
                  <FormattedHTMLMessage id="petspage.text67" />
                </p>
                <img className="slide-up" onClick={() => {
                  setSlideOpen(99)
                  document.getElementById('ambassador-slider').scrollIntoView()
                }} src={SlideUp} alt="close slide icon"/>
              </div>
              <p><b>{ intl.locale == 'fr' ? 'Suivant':'Up Next'}</b>: Franklin & Penny Oleksiak</p>

            </Slide>


          </Slider>
        </div>
      </IsMobile>
    </>
  )
}

export default injectIntl(PetsAmbassador)
